import { Options } from '@angular-slider/ngx-slider';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinViewerComponent } from '@egjs/ngx-view360';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IMG_CAMINHO } from 'src/app/app.api';
import { Apartamento } from 'src/app/shared/model/apartamento.model';
import { Contador } from 'src/app/shared/model/contador.model';
import { Metragem } from 'src/app/shared/model/metragem.model';
import { Planta } from 'src/app/shared/model/planta.model';
import { DataService } from 'src/app/shared/service/data.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import lgZoom from 'lightgallery/plugins/zoom';
import { BeforeSlideDetail, InitDetail } from 'lightgallery/lg-events';
import { LightGallery } from 'lightgallery/lightgallery';
import { DOCUMENT } from '@angular/common';

declare var $: any;

@Component({
  selector: 'dom436-apartment-select',
  templateUrl: './apartment-select.component.html'
})
export class ApartmentSelectComponent implements OnInit, AfterViewInit {
  metragens: Metragem[];
  apartamentos: Apartamento[] = [];
  galeriaImagens: String[] = ['assets/images/gallery_1.jpg', 'assets/images/gallery_2.jpg', 'assets/images/gallery_3.jpg'];
  galeriaImagemAtual: number = 1;
  galeriaPrev = true;
  galeriaNext = true;
  plantas: Planta[] [];
  galeriaPlantasImagens: String[] = [];
  galeriaPlantasImagemAtual: number = 1;
  galeriaPlantasPrev = true;
  galeriaPlantasNext = true;
  selectedStatus: any = null;
  selectedMetragem: any;
  selectedPrecoMin: any;
  selectedPrecoMax: any;
  selectedAndarMin: any;
  selectedAndarMax: any;
  selectedMetragemMin: any;
  selectedMetragemMax: any;
  selectedElement: number;
  selectedApartamento: Apartamento;
  selectedQuarto: any;
  selectedPlanta: any;
  modalRef: BsModalRef;
  selectedUrlMetragem: Metragem = {id: undefined, valor: undefined};
  selectedPlantaImg: string = null;
  selectedApartmentImg: string = null;
  selectedApartmentDetail: Apartamento = null;
  selectedApartmentTooltip: Apartamento = null;
  posicaoAtualSvg: number = null;
  posicaoAtualMenuView: string = 'overview';
  mapFilterEnabled: boolean = false;
  pinFarmaciaEnabled: boolean = true;
  pinHospitalEnabled: boolean = true;
  pinLojaEnabled: boolean = true;
  pinRestauranteEnabled: boolean = true;
  pinSupermercadoEnabled: boolean = true;
  range5minEnabled: boolean = true;
  range10minEnabled: boolean = true;
  backgroundSprite: string = '4pm';
  isLoading: boolean = true;
  lightGalleryGaleria!: LightGallery;
  lightGalleryPlanta!: LightGallery;
  @ViewChild('ngxSpinViewer9am', { static: true }) ngxSpinViewer9am: NgxSpinViewerComponent;
  @ViewChild('ngxSpinViewer4pm', { static: true }) ngxSpinViewer4pm: NgxSpinViewerComponent;
  @ViewChild('ngxSpinViewer8pm', { static: true }) ngxSpinViewer8pm: NgxSpinViewerComponent;
  @ViewChild('ngxSpinViewer9amMobile', { static: true }) ngxSpinViewer9amMobile: NgxSpinViewerComponent;
  @ViewChild('ngxSpinViewer4pmMobile', { static: true }) ngxSpinViewer4pmMobile: NgxSpinViewerComponent;
  @ViewChild('ngxSpinViewer8pmMobile', { static: true }) ngxSpinViewer8pmMobile: NgxSpinViewerComponent;

  settingsGallery = {
    counter: false,
    plugins: [lgZoom]
  };
  onBeforeSlideGallery = (detail: BeforeSlideDetail): void => {
    const { index, prevIndex } = detail;
    console.log(index, prevIndex);
  };
  onInitGaleria = (detail: InitDetail): void => {
    this.lightGalleryGaleria = detail.instance;
  };
  onInitPlanta = (detail: InitDetail): void => {
    this.lightGalleryPlanta = detail.instance;
  };

  carouselOptions: OwlOptions = {
    items: 1,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    nav: true,
    navText:["<div class='nav-btn prev-slide'><img alt='Seta' src='assets/images/arrow-left-black.svg' /></div>","<div class='nav-btn next-slide'><img alt='Seta' src='assets/images/arrow-right-black.svg' /></div>"],
    autoplay: true,
    autoWidth: true,
    autoHeight: true,
    responsive: {
      0: {
        items: 1 
      }
    },
  }

  minValue: number = 0;
  maxValue: number = 500;
  options: Options = {
    showTicksValues: false,
    floor: 0,
    ceil: 500,
    step: 100
  };

  minValueAndar: number = 0;
  maxValueAndar: number = 12;
  optionsAndar: Options = {
    showTicksValues: false,
    floor: 1,
    ceil: 12,
    step: 1
  };

  minValueMetragem: number = 0;
  maxValueMetragem: number = 200;
  optionsMetragem: Options = {
    showTicksValues: false,
    floor: 0,
    ceil: 200,
    step: 1
  };

  constructor(
    private modalService: BsModalService,
    private dataService: DataService,
    private router: Router,
    ) {
      let state = this.router.getCurrentNavigation().extras.state as {selectedMetragem: Metragem};
      if(state) {
        this.selectedUrlMetragem = state.selectedMetragem;
        this.selectedMetragem = this.selectedUrlMetragem.id+'';
      }
    }
  
  ngOnInit() {
    this.dataService.listApartamentos()
      .subscribe(apartamentos => {
        this.apartamentos = apartamentos;
        this.addClasses('start');
        this.getMaxValue();
        this.getPlantasImages();
      });
  }

  ngAfterViewInit(): void {
    this.girarLivremente();
    $('.selectpicker').selectpicker();
    this.dataService.listMetragens()
      .subscribe(metragens => {
        this.metragens = metragens;
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
          if(this.selectedMetragem) {
            this.addClasses('filter');
          }
          this.isLoading = false;
        }, 5000);
      });
  }

  selectChangeStatus(selectedStatus: any) {
    this.selectedStatus = selectedStatus;
    this.addClasses('filter');
  }

  selectChangeQuarto(selectedQuarto: any) {
    this.selectedQuarto = selectedQuarto;
    this.addClasses('filter');
  }

  selectChangePlanta(selectedPlanta: any, type: string) {
    this.selectedPlanta = selectedPlanta;
    this.addClasses(type);
    if(type === 'filterClean') {
      this.selectedPlanta = null;
    }
  }

  selectElement(value: number) {
    let clickedApartment = this.apartamentos.filter(apartamento => { return apartamento.id === value})[0];
    this.incrementarContador(clickedApartment.id, 1);
    if(clickedApartment.status === 2) {
      alert('Este apartamento já foi vendido. Por favor selecione outra unidade.');
    } else {
      if(this.selectedElement === value) {
        this.incrementarContador(clickedApartment.id, 2);
        this.router.navigate(['/selecionar-segmento']);
      }
      this.removeShow('clicked');
      this.addClasses('filter');
      if(this.selectedElement) {
        let elementAnterior = document.getElementById('_'+this.selectedElement) as HTMLElement;
        let classAnterior = elementAnterior.getAttribute('class');
        elementAnterior.setAttribute('class', classAnterior.replace('clicked', ''));
        let elementTextAnterior = document.getElementById('description'+this.selectedElement) as HTMLElement;
        let classTextAnterior = elementTextAnterior.getAttribute('class');
        elementTextAnterior.setAttribute('class', classTextAnterior.replace('show', ''));
      }
      this.selectedElement = value;
      this.selectedApartamento = clickedApartment;
      sessionStorage.setItem('selectedApartamento', JSON.stringify(this.selectedApartamento));
      let elementNovo = document.getElementById('_'+value) as HTMLElement;
      let classNovo = elementNovo.getAttribute('class');
      elementNovo.setAttribute('class', classNovo+' clicked');
      let elementTextNovo = document.getElementById('description'+value) as HTMLElement;
      let classTextNovo = elementTextNovo.getAttribute('class');
      elementTextNovo.setAttribute('class', classTextNovo.replace('show', ''));
      elementTextNovo.setAttribute('class', classTextNovo+' show');
    }
  }

  displayText(value) {
    let element = document.getElementById('description'+value) as HTMLElement;
    element.style.display = 'block';
    let elementExterno = document.getElementById('_'+value) as HTMLElement;
    let classAtual = elementExterno.getAttribute('class');
    elementExterno.setAttribute('class', classAtual+' fix');
    //this.displayPlanta(value);
  }

  hiddenText(value) {
    let element = document.getElementById('description'+value) as HTMLElement;
    element.style.display = 'none';
    let elementExterno = document.getElementById('_'+value) as HTMLElement;
    let classAtual = elementExterno.getAttribute('class');
    elementExterno.setAttribute('class', classAtual.replace('fix', ''));
    this.hiddenPlanta();
  }

  displayPlanta() {
    this.selectedPlantaImg = IMG_CAMINHO+this.selectedApartmentDetail.planta.imagem;
  }

  hiddenPlanta() {
    this.selectedPlantaImg = null;
  }

  displayImagemApartamento() {
    this.selectedApartmentImg = IMG_CAMINHO+this.selectedApartmentDetail.imagem;
  }

  displayDetails(value) {
    this.hiddenPlanta();
    this.selectedApartmentDetail = this.apartamentos.filter(apartamento => { return apartamento.id === value})[0];
    sessionStorage.setItem('selectedApartamento', JSON.stringify(this.selectedApartmentDetail));
  }
  
  displayTooltip(value) {
    this.selectedApartmentTooltip = this.apartamentos.filter(apartamento => { return apartamento.id === value})[0];
  }

  hiddenDetails() {
    this.hiddenPlanta();
    this.selectedApartmentDetail = null;
  }

  hiddenFilters() {
    this.posicaoAtualMenuView = 'filtros-hidden';
  }

  closeFilters() {
    this.posicaoAtualMenuView = 'overview';
    this.girarLivremente();
  }
  
  displayMapFilters() {
    this.mapFilterEnabled = true;
  }
  
  hiddenMapFilters() {
    this.mapFilterEnabled = false;
  }

  mapFilterChange(values: any) {
    let pinElement = values.currentTarget;
    if(pinElement.value === 'farmacia') {
      this.pinFarmaciaEnabled = pinElement.checked;
    } else if(pinElement.value === 'hospital') {
      this.pinHospitalEnabled = pinElement.checked;
    } else if(pinElement.value === 'loja') {
      this.pinLojaEnabled = pinElement.checked;
    } else if(pinElement.value === 'restaurante') {
      this.pinRestauranteEnabled = pinElement.checked;
    } else if(pinElement.value === 'supermercado') {
      this.pinSupermercadoEnabled = pinElement.checked;
    }
  }

  mapRangeChange(values: any) {
    let rangeElement = values.currentTarget;
    if(rangeElement.value === 'range5min') {
      this.range5minEnabled = rangeElement.checked;
    } else if(rangeElement.value === 'range10min') {
      this.range10minEnabled = rangeElement.checked;
    }
  }

  backgroundChange(value: string) {
    if(value === 'm') {
      if(this.backgroundSprite === '4pm') {
        this.ngxSpinViewer9am.spinTo(this.ngxSpinViewer4pm.getAngle());
        this.ngxSpinViewer9amMobile.spinTo(this.ngxSpinViewer4pmMobile.getAngle());
      } else if(this.backgroundSprite === '8pm') {
        this.ngxSpinViewer9am.spinTo(this.ngxSpinViewer8pm.getAngle());
        this.ngxSpinViewer9amMobile.spinTo(this.ngxSpinViewer8pmMobile.getAngle());
      }
      this.backgroundSprite = '9am';
    } else if(value === 't') {
      if(this.backgroundSprite === '9am') {
        this.ngxSpinViewer4pm.spinTo(this.ngxSpinViewer9am.getAngle());
        this.ngxSpinViewer4pmMobile.spinTo(this.ngxSpinViewer9amMobile.getAngle());
      } else if(this.backgroundSprite === '8pm') {
        this.ngxSpinViewer4pm.spinTo(this.ngxSpinViewer8pm.getAngle());
        this.ngxSpinViewer4pmMobile.spinTo(this.ngxSpinViewer8pmMobile.getAngle());
      }
      this.backgroundSprite = '4pm';
    } else if(value === 'n') {
      if(this.backgroundSprite === '9am') {
        this.ngxSpinViewer8pm.spinTo(this.ngxSpinViewer9am.getAngle());
        this.ngxSpinViewer8pmMobile.spinTo(this.ngxSpinViewer9amMobile.getAngle());
      } else if(this.backgroundSprite === '4pm') {
        this.ngxSpinViewer8pm.spinTo(this.ngxSpinViewer4pm.getAngle());
        this.ngxSpinViewer8pmMobile.spinTo(this.ngxSpinViewer4pmMobile.getAngle());
      }
      this.backgroundSprite = '8pm';
    }
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  }

  addClasses(type: string) {
    this.apartamentos.forEach(apartamento => {
      document.querySelectorAll('[id=_'+apartamento.id+']').forEach(elementQuery => {
        let element = elementQuery as HTMLElement;
        let classAtual = element.getAttribute('class');
        if(type === 'start') {
          if(apartamento.status === 1) {
            element.setAttribute('class', classAtual+' available-shape');
          } else if(apartamento.status === 2) {
            element.setAttribute('class', classAtual+' unavailable-shape');
          } else if(apartamento.status === 3) {
            element.setAttribute('class', classAtual+' reserved-shape');
          }
        } else if(type === 'filter') {
          element.setAttribute('class', classAtual.replace(' unfiltered', ''));
          let elementUnfiltered = false;
          classAtual = element.getAttribute('class');
          if(apartamento.preco < this.selectedPrecoMin || apartamento.preco > this.selectedPrecoMax) {
              element.setAttribute('class', classAtual+' unfiltered');
              elementUnfiltered = true;
          } 
          if(apartamento.planta.metragem.valor < this.selectedMetragemMin || apartamento.planta.metragem.valor > this.selectedMetragemMax) {
            if(!elementUnfiltered) {
              element.setAttribute('class', classAtual+' unfiltered');
              elementUnfiltered = true;
            }
          } if(apartamento.andar < this.selectedAndarMin || apartamento.andar > this.selectedAndarMax) {
            if(!elementUnfiltered) {
              element.setAttribute('class', classAtual+' unfiltered');
              elementUnfiltered = true;
            }
          }
          if(!elementUnfiltered) {
            if(this.selectedStatus && this.selectedPlanta) {
              if(apartamento.planta.id !== this.selectedPlanta || apartamento.status !== this.selectedStatus) {
                element.setAttribute('class', classAtual+' unfiltered');
              }
            } else if(this.selectedStatus && !this.selectedPlanta) {
              if(apartamento.status !== this.selectedStatus) {
                element.setAttribute('class', classAtual+' unfiltered');
              }
            } else if(!this.selectedStatus && this.selectedPlanta) {
              if(apartamento.planta.id !== this.selectedPlanta) {
                element.setAttribute('class', classAtual+' unfiltered');
              }
            }
          }
        } else if(type === 'filterClean') {
          element.setAttribute('class', classAtual.replace(' unfiltered', ''));
        }
      });
    });
  }

  removeClasses() {
    this.selectedStatus = null;
    this.selectedQuarto = null;
    this.addClasses('filterClean');
    this.getMaxValue();
    this.minValueAndar = 0;
    this.maxValueAndar = 12;
  }

  removeShow(type: string) {
    this.apartamentos.forEach(apartamento => {
      if(type === 'filter') {
        if(apartamento.id !== this.selectedElement) {
          let elementText = document.getElementById('description'+apartamento.id) as HTMLElement;
          let classTextAtual = elementText.getAttribute('class');
          elementText.setAttribute('class', classTextAtual.replace('show', ''));
        }
      } else if(type === 'clicked') {
        let elementText = document.getElementById('description'+apartamento.id) as HTMLElement;
        let classTextAtual = elementText.getAttribute('class');
        elementText.setAttribute('class', classTextAtual.replace('show', ''));
      }
    });
  }

  goDecorator() {
    this.router.navigate(['/decorar-apartamento/novo'], {state: {selectedSegment: 1}});
  }

  getFormattedValue(valor: number) {
    return new Intl.NumberFormat('pt-BR',{minimumFractionDigits: 2}).format(valor);
  }

  getMaxValue() {
    let minValue = 9999999999999;
    let maxValue = 0;
    this.apartamentos.forEach(apartamento => {
      if(apartamento.preco < minValue) {
        minValue = apartamento.preco;
      }
      if(apartamento.preco > maxValue) {
        maxValue = apartamento.preco;
      }
    });
    this.minValue = minValue;
    this.maxValue = maxValue+1000;
    this.options = {
      showTicksValues: false,
      floor: minValue,
      ceil: maxValue+1000,
      step: 100,
      translate: (value: number): string => {
        return 'R$'+this.getFormattedValue(value);
      }
    };
    this.getMaxValueMetragem();
  }

  getMaxValueMetragem() {
    let minValue = 99999999;
    let maxValue = 0;
    this.apartamentos.forEach(apartamento => {
      if(apartamento.planta.metragem.valor < minValue) {
        minValue = apartamento.planta.metragem.valor;
      }
      if(apartamento.planta.metragem.valor > maxValue) {
        maxValue = apartamento.planta.metragem.valor;
      }
    });
    this.minValueMetragem = minValue;
    this.maxValueMetragem = maxValue+1;
    this.optionsMetragem = {
      showTicksValues: false,
      floor: minValue,
      ceil: maxValue+1,
      step: 1,
      translate: (value: number): string => {
        return this.getFormattedValue(value);
      }
    };
  }

  getPlantasImages() {
    this.dataService.listPlantas()
      .subscribe(plantas => {
        this.plantas = plantas;
        plantas.forEach(planta => {
          this.galeriaPlantasImagens.push(IMG_CAMINHO+planta.imagem);
        });
      });
    }

  sliderChangeMin(value, type) {
    if(type === 'preco') {
      this.selectedPrecoMin = value;
    } else if(type === 'andar') {
      this.selectedAndarMin = value;
    } else if(type === 'metragem') {
      this.selectedMetragemMin = value;
    }
    this.addClasses('filter');
  }

  sliderChangeMax(value, type) {
    if(type === 'preco') {
      this.selectedPrecoMax = value;
    } else if(type === 'andar') {
      this.selectedAndarMax = value;
    } else if(type === 'metragem') {
      this.selectedMetragemMax = value;
    }
    this.addClasses('filter');
  }

  incrementarContador(apartamentoId, tipo) {
    let contador: Contador = {apartamentoId, tipo};
    contador.apartamentoId = apartamentoId;
    contador.tipo = tipo;
    this.dataService.incrementarContador(contador)
      .subscribe();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      { class: 'modal-selector' }
    );
  }
  
  fixarPosicao(value) {
    value = parseInt(value);
    this.posicaoAtualSvg = value;
    let svgPositionOne = document.getElementsByClassName('svg-position-one')[0] as HTMLElement;
    let svgPositionTwo = document.getElementsByClassName('svg-position-two')[0] as HTMLElement;
    let svgPositionThree = document.getElementsByClassName('svg-position-three')[0] as HTMLElement;
    let svgPositionFour = document.getElementsByClassName('svg-position-four')[0] as HTMLElement;
    let svgPositionOneMobile = document.getElementsByClassName('svg-position-one-mobile')[0] as HTMLElement;
    let svgPositionTwoMobile = document.getElementsByClassName('svg-position-two-mobile')[0] as HTMLElement;
    let svgPositionThreeMobile = document.getElementsByClassName('svg-position-three-mobile')[0] as HTMLElement;
    let svgPositionFourMobile = document.getElementsByClassName('svg-position-four-mobile')[0] as HTMLElement;
    if(value === 1) {
      setTimeout(() => {
        svgPositionTwo.style.display = 'none';
        svgPositionThree.style.display = 'none';
        svgPositionFour.style.display = 'none';
        svgPositionOne.style.display = 'block';
        svgPositionTwoMobile.style.display = 'none';
        svgPositionThreeMobile.style.display = 'none';
        svgPositionFourMobile.style.display = 'none';
        svgPositionOneMobile.style.display = 'block';
      }, 1000);
      svgPositionTwo.style.display = 'none';
      svgPositionThree.style.display = 'none';
      svgPositionFour.style.display = 'none';
      this.ngxSpinViewer9am.spinTo(350, {duration: 1000});
      this.ngxSpinViewer4pm.spinTo(350, {duration: 1000});
      this.ngxSpinViewer8pm.spinTo(350, {duration: 1000});
      this.ngxSpinViewer9amMobile.spinTo(350, {duration: 1000});
      this.ngxSpinViewer4pmMobile.spinTo(350, {duration: 1000});
      this.ngxSpinViewer8pmMobile.spinTo(350, {duration: 1000});
    } else if(value === 2) {
      setTimeout(() => {
        svgPositionOne.style.display = 'none';
        svgPositionThree.style.display = 'none';
        svgPositionFour.style.display = 'none';
        svgPositionTwo.style.display = 'block';
        svgPositionOneMobile.style.display = 'none';
        svgPositionThreeMobile.style.display = 'none';
        svgPositionFourMobile.style.display = 'none';
        svgPositionTwoMobile.style.display = 'block';
      }, 1000);
      svgPositionOne.style.display = 'none';
      svgPositionThree.style.display = 'none';
      svgPositionFour.style.display = 'none';
      svgPositionOneMobile.style.display = 'none';
      svgPositionThreeMobile.style.display = 'none';
      svgPositionFourMobile.style.display = 'none';
      this.ngxSpinViewer9am.spinTo(250, {duration: 1000});
      this.ngxSpinViewer4pm.spinTo(250, {duration: 1000});
      this.ngxSpinViewer8pm.spinTo(250, {duration: 1000});
      this.ngxSpinViewer9amMobile.spinTo(250, {duration: 1000});
      this.ngxSpinViewer4pmMobile.spinTo(250, {duration: 1000});
      this.ngxSpinViewer8pmMobile.spinTo(250, {duration: 1000});
    } else if(value === 3) {
      setTimeout(() => {
        svgPositionOne.style.display = 'none';
        svgPositionTwo.style.display = 'none';
        svgPositionThree.style.display = 'block';
        svgPositionFour.style.display = 'none';
        svgPositionOneMobile.style.display = 'none';
        svgPositionTwoMobile.style.display = 'none';
        svgPositionThreeMobile.style.display = 'block';
        svgPositionFourMobile.style.display = 'none';
      }, 1000);
      svgPositionOne.style.display = 'none';
      svgPositionTwo.style.display = 'none';
      svgPositionFour.style.display = 'none';
      svgPositionOneMobile.style.display = 'none';
      svgPositionTwoMobile.style.display = 'none';
      svgPositionFourMobile.style.display = 'none';
      this.ngxSpinViewer9am.spinTo(177, {duration: 1000});
      this.ngxSpinViewer4pm.spinTo(177, {duration: 1000});
      this.ngxSpinViewer8pm.spinTo(177, {duration: 1000});
      this.ngxSpinViewer9amMobile.spinTo(177, {duration: 1000});
      this.ngxSpinViewer4pmMobile.spinTo(177, {duration: 1000});
      this.ngxSpinViewer8pmMobile.spinTo(177, {duration: 1000});
    } else if(value === 4) {
      svgPositionOne.style.display = 'none';
      svgPositionTwo.style.display = 'none';
      svgPositionThree.style.display = 'none';
      svgPositionOneMobile.style.display = 'none';
      svgPositionTwoMobile.style.display = 'none';
      svgPositionThreeMobile.style.display = 'none';
      setTimeout(() => {
        svgPositionOne.style.display = 'none';
        svgPositionTwo.style.display = 'none';
        svgPositionThree.style.display = 'none';
        svgPositionFour.style.display = 'block';
        svgPositionOneMobile.style.display = 'none';
        svgPositionTwoMobile.style.display = 'none';
        svgPositionThreeMobile.style.display = 'none';
        svgPositionFourMobile.style.display = 'block';
      }, 1000);
      this.ngxSpinViewer9am.spinTo(127, {duration: 1000});
      this.ngxSpinViewer4pm.spinTo(127, {duration: 1000});
      this.ngxSpinViewer8pm.spinTo(127, {duration: 1000});
      this.ngxSpinViewer9amMobile.spinTo(127, {duration: 1000});
      this.ngxSpinViewer4pmMobile.spinTo(127, {duration: 1000});
      this.ngxSpinViewer8pmMobile.spinTo(127, {duration: 1000});
    }
    if(this.posicaoAtualMenuView === 'overview') {
      setTimeout(() => {
        svgPositionOne.style.display = 'none';
        svgPositionTwo.style.display = 'none';
        svgPositionThree.style.display = 'none';
        svgPositionFour.style.display = 'none';
        svgPositionOneMobile.style.display = 'none';
        svgPositionTwoMobile.style.display = 'none';
        svgPositionThreeMobile.style.display = 'none';
        svgPositionFourMobile.style.display = 'none';
      }, 1000);
    }
  }

  mudarPosicao(tipo) {
    if(tipo === 'prev') {
      let novaPosicao = this.posicaoAtualSvg - 1;
      if(novaPosicao <= 0) {
        this.fixarPosicao(4);
      } else {
        this.fixarPosicao(novaPosicao);
      }
    } else {
      let novaPosicao = this.posicaoAtualSvg + 1;
      if(novaPosicao >= 5) {
        this.fixarPosicao(1);
      } else {
        this.fixarPosicao(novaPosicao);
      }
    }
  }

  mudarImagemGaleria(tipo) {
    let galeriaImagensTotal = this.galeriaImagens.length - 1;
    if(tipo === 'prev') {
      if(this.galeriaImagemAtual - 1 === 0) {
        this.galeriaImagemAtual = this.galeriaImagemAtual - 1;
        this.galeriaPrev = false;
      } else {
        this.galeriaImagemAtual = this.galeriaImagemAtual - 1;
        this.galeriaNext = true;
      }
    } else {
      if(this.galeriaImagemAtual + 1 === galeriaImagensTotal) {
        this.galeriaImagemAtual = this.galeriaImagemAtual + 1;
        this.galeriaNext = false;
      } else {
        this.galeriaImagemAtual = this.galeriaImagemAtual + 1;
        this.galeriaPrev = true;
      }
    }
  }

  mudarImagemGaleriaPlantas(tipo) {
    let galeriaPlantasImagensTotal = this.galeriaPlantasImagens.length - 1;
    if(tipo === 'prev') {
      if(this.galeriaPlantasImagemAtual - 1 === 0) {
        this.galeriaPlantasImagemAtual = this.galeriaPlantasImagemAtual - 1;
        this.galeriaPlantasPrev = false;
      } else {
        this.galeriaPlantasImagemAtual = this.galeriaPlantasImagemAtual - 1;
        this.galeriaPlantasNext = true;
      }
    } else {
      if(this.galeriaPlantasImagemAtual + 1 === galeriaPlantasImagensTotal) {
        this.galeriaPlantasImagemAtual = this.galeriaPlantasImagemAtual + 1;
        this.galeriaPlantasNext = false;
      } else {
        this.galeriaPlantasImagemAtual = this.galeriaPlantasImagemAtual + 1;
        this.galeriaPlantasPrev = true;
      }
    }
  }

  girarLivremente() {
    this.fixarPosicao(0);
    this.posicaoAtualMenuView = 'overview';
    let svgPositionOne = document.getElementsByClassName('svg-position-one')[0] as HTMLElement;
    let svgPositionTwo = document.getElementsByClassName('svg-position-two')[0] as HTMLElement;
    let svgPositionThree = document.getElementsByClassName('svg-position-three')[0] as HTMLElement;
    let svgPositionFour = document.getElementsByClassName('svg-position-four')[0] as HTMLElement;
    let svgPositionOneMobile = document.getElementsByClassName('svg-position-one-mobile')[0] as HTMLElement;
    let svgPositionTwoMobile = document.getElementsByClassName('svg-position-two-mobile')[0] as HTMLElement;
    let svgPositionThreeMobile = document.getElementsByClassName('svg-position-three-mobile')[0] as HTMLElement;
    let svgPositionFourMobile = document.getElementsByClassName('svg-position-four-mobile')[0] as HTMLElement;
    svgPositionOne.style.display = 'none';
    svgPositionTwo.style.display = 'none';
    svgPositionThree.style.display = 'none';
    svgPositionFour.style.display = 'none';
    svgPositionOneMobile.style.display = 'none';
    svgPositionTwoMobile.style.display = 'none';
    svgPositionThreeMobile.style.display = 'none';
    svgPositionFourMobile.style.display = 'none';
  }

  mudarVisao(opcao) {
    this.posicaoAtualMenuView = opcao;
    if(!this.posicaoAtualSvg && opcao !== 'overview' && opcao !== 'galeria' && opcao !== 'plantas') {
      this.fixarPosicao(1);
    } else if(opcao === 'galeria') {
      this.lightGalleryGaleria.openGallery(1);
      this.posicaoAtualMenuView = 'overview';
    } else if(opcao === 'plantas') {
      this.lightGalleryPlanta.openGallery(1);
      this.posicaoAtualMenuView = 'overview';
    }
  }

}